<template>
  <CRow>
    <CCol sm="12" xs="12" md="12" lg="12" xl="12" class="text-center">
      <CCard>
        <header class="card-header w-100">
          <b>COMANDAS DEL D&Iacute;A</b>
          <button
            @click="mtdBack"
            type="button"
            class="btn btn-sm text-white float-right"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Ir a Inicio
          </button>
        </header>
      </CCard>
    </CCol>
    <CCol sm="12" xs="12" md="2" lg="2" xl="2">
      <CCard
        v-for="(item, index) in allCommands"
        :key="index"
        @click="mtdSelectCommand(index)"
        :class="mtdGetClassCommand(index,item.state, item.type)"
      >
        <CCardHeader class="text-center text-uppercase font-weight-bold">
          <span v-if="item.type === 'delivery'" class="badge badge-warning">
            <i class="fas fa-motorcycle"></i> DELIVERY
          </span>
          {{ item.name }}
        </CCardHeader>
      </CCard>
    </CCol>
    <CCol sm="12" xs="12" md="9" lg="9" xl="9" v-if="posSelectCommand >= 0">
      <CRow>
        <CCol sm="12" xs="12" md="12" lg="12" xl="12">
          <CCard>
            <CCardBody style="background-color: cadetblue">
              <CRow
                v-for="(item, pos) in comands"
                :key="pos"
              >
                <CCol
                  sm="12"
                  xs="12"
                  md="4"
                  lg="4"
                  xl="4"
                  v-if="item.type == 1"
                >
                  <CCard>
                    <header class="card-header w-100">
                      {{ item.label_cocina }}
                      <span :class="mtdGetClassItem(item.state)">{{
                        mtdGetStateItem(item.state)
                      }}</span>
                    </header>
                  </CCard>
                </CCol>
                <CCol
                  sm="12"
                  xs="12"
                  md="6"
                  lg="6"
                  xl="6"
                  v-if="item.type == 1"
                >
                  <CInput type="text" disabled v-model="item.anotation">
                  </CInput>
                </CCol>
                <CCol
                  sm="12"
                  xs="12"
                  md="2"
                  lg="2"
                  xl="2"
                  v-if="item.type == 1"
                >
                  <CButton
                    v-if="item.state == 1 && item.status !=3 "
                    @click="mtdSetStateItem(pos, 2)"
                    class="text-white w-100"
                    color="warning"
                    ><i class="fas fa-drumstick-bite"></i> Preparar</CButton
                  >
                  <CButton
                    v-if="item.state == 2 && item.status != 3"
                    @click="mtdSetStateItem(pos, 3)"
                    class="text-white w-100"
                    color="success"
                    > <i class="fas fa-box"></i> Entregar</CButton
                  >
                  <CButton
                    v-if="item.status == 3"
                    class="text-white w-100"
                    color="danger"
                    > <i class="fas fa-ban"></i> Pendiente</CButton
                  >
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import { mapActions } from "vuex";
import { CInput, CRow } from "@coreui/vue-pro";

export default {
  name: "comandas-cocina",
  data() {
    return {
      prefix:'cocina',
      tables: [],
      deliveries: [],
      comands:[],
      posSelectCommand: -1, // comanda seleccionada
      posSelectItem: -1, // plato select
    };
  },
  computed: {
    allCommands() {
      // Combinar mesas y deliveries en una sola lista
      return [...this.tables, ...this.deliveries];
    }
  },
  created() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack() {
      this.$emit("setView", "home");
    },
    mtdGetData: function () {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/index/"+this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.tables = response.data.table;
          this.deliveries = response.data.deliveries || [];
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectCommand: function (pos) {
      const allCmds = this.allCommands;
      const selectedCommand = allCmds[pos];
      
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/getcomand/"+ selectedCommand.sale,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.posSelectCommand = pos;
          this.comands = response.data.comand;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectItem: function (payload) {
      this.posSelectItem = payload;
    },
    mtdGetClassItem: function (state) {
      const parseState = parseInt(state);
      let resClas = "";
      switch (parseState) {
        case 1:
          resClas = "badge float-right badge-danger";
          break;
        case 2:
          resClas = "badge float-right badge-warning";
          break;
        case 3:
          resClas = "badge float-right badge-success";
          break;
        default:
          break;
      }
      return resClas;
    },
    mtdGetStateItem: function (state) {
      const parseState = parseInt(state);
      let resText = "";
      switch (parseState) {
        case 1:
          resText = "Pendiente";
          break;
        case 2:
          resText = "Preparando";
          break;
        case 3:
          resText = "Entregado";
          break;
        default:
          break;
      }
      return resText;
    },
    mtdSetStateItem: function (pos, state) {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/upstate",
        token: this.$store.getters.get__token,
        params: {
            det: this.comands[pos].idDet,
            state: state
        }
      })
        .then((response) => {
            this.comands[pos].state = state;
            const allCmds = this.allCommands;
            const selectedCommand = allCmds[this.posSelectCommand];
            
            // Actualizar estado de la comanda/delivery
            if (selectedCommand) {
              selectedCommand.state = 2;
              if (this.mtdVerifCompleteCommand()) {
                selectedCommand.state = 3;
                // Remover de la lista correspondiente
                if (selectedCommand.type === 'delivery') {
                  const deliveryIndex = this.deliveries.findIndex(d => d.id === selectedCommand.id);
                  if (deliveryIndex !== -1) {
                    this.deliveries.splice(deliveryIndex, 1);
                  }
                } else {
                  const tableIndex = this.tables.findIndex(t => t.id === selectedCommand.id);
                  if (tableIndex !== -1) {
                    this.tables.splice(tableIndex, 1);
                  }
                }
                this.posSelectCommand = -1;
              }
            }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdVerifCompleteCommand: function () {
      let boo = true;
      this.comands.forEach((element) => {
        if (element.state != 3 && element.type == 1) {
          boo = false;
        }
      });
      return boo;
    },
    mtdGetClassCommand: function(pos, state, type){
      if (pos == this.posSelectCommand) {
        return type === 'delivery' ? 'bg-warning text-white' : 'bg-info text-white';
      } else {
        if (parseInt(state) === 1) {
          return type === 'delivery' ? 'border-warning' : '';
        }
        return '';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.border-warning {
  border: 2px solid #ffc107;
}
</style>
